module.exports = __webpack_public_path__ + "static/img/open-title-5.daeaad34.png";